module.exports = {
	PALAVRA_CHAVE: 'R3p0s1t0r10',
	SERVICO_WEBAULA: 'http://lmsapiestacio.webaula.com.br'
}
